module.exports = __webpack_public_path__ + "static/media/galdisa_productos_cacahuate_valencia.b4580f6b.png";